<template>
  <div ref="image" :class="['canvas-image']" @click="click">
    <svg
      height="100%"
      width="100%"
      :viewBox="`0 0 ${mask.artBoard.width} ${mask.artBoard.height}`"
      v-if="paint.shape !== 'rettangolo'"
    >
      <defs>
        <clipPath :id="`svgPath-${paint.id}`">
          <path :d="mask.path" />
        </clipPath>
        <filter :id="`svgShadow-${paint.id}`">
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="18"
            flood-color="rgba(0,0,0,.5)"
          />
        </filter>
      </defs>
      <path
        :d="mask.path"
        :filter="`url(#svgShadow-${paint.id})`"
        :style="{ fill: 'black' }"
      />
      <image
        :clip-path="`url(#svgPath-${paint.id})`"
        height="100%"
        width="100%"
        :xlink:href="src"
      />
    </svg>
  </div>
</template>

<script>
import masks from "@/assets/content/masks.json";
export default {
  props: ["paint"],
  data() {
    return {
      masks,
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    mask() {
      return this.masks[this.paint.id];
    },
    src() {
      let folder = "";
      if (this.$tvaMq === "desktop" || this.$tvaMq === "tablet") {
        if (this.paint.width < 300) {
          folder = "500";
        } else {
          folder = "800";
        }
      } else if (this.$tvaMq === "large") {
        folder = "800";
      } else {
        if (this.paint.width < 300) {
          folder = "300";
        } else {
          folder = "500";
        }
      }

      return `${this.baseUrl}assets/paintings/${folder}/${this.paint.id}-0.jpg`;
    }
  },
  methods: {
    click() {
      this.$emit("click", event);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const img = new Image();
      img.src = this.src;
      img
        .decode()
        .then(() => {
          if (this.$refs.image && this.paint.shape === "rettangolo") {
            this.$refs.image.appendChild(img);
          }
        })
        .catch(encodingError => {
          console.log(encodingError);
        });
    });
  }
};
</script>
<style lang="scss" scoped>
.canvas-image {
  svg {
    overflow: visible;
    animation: fade 3s ease;
    pointer-events: none;
  }
}
</style>
<style lang="scss">
.canvas-image {
  user-select: none;
  img {
    animation: fade 3s ease;
    height: 100%;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
    pointer-events: none;
  }
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
</style>
